export default __webpack_public_path__ + "static/media/011-rhombus-green.f41b1dd6.svg";